import React, { useEffect, useRef, useState } from 'react';
import {
  Col, Container, Icons, Row,
} from '../../../components/base/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import Pagination from '../../../components/base/Pagination/Pagination';
import {
  addressFormatter,
  optionClassFormatter, statusNameFormatterWithZone,
} from '../../../utils/formatters';
import { StatusFormatterWithProblem } from '../../ParkingMeter/components/ParkingFormatters';
import { processingFormatter } from '../camera-utils';
import { CamerasActionsFormatter, CamerasWorkingStateFormatter } from './CamerasFormatters';

export default function CamerasGrid(props) {
  const {
    camerasList,
    camerasListMeta,
    handleLoadingCamerasList,
    loading,
    showOnMap = () => {},
    sort = [],
    changeSort = () => {},
  } = props;

  const columns = [
    {
      dataField: 'host',
      text: 'Номер видеокамеры',
      formatter: statusNameFormatterWithZone,
      dataClassName: 'align-middle position-relative',
    },
    {
      dataField: 'zbx_address',
      text: 'Адрес факт. / юрид.',
      formatter: (address, item) => addressFormatter(address, false, null, false, () => showOnMap(item)),
      dataClassName: 'align-middle',
    },
    {
      dataField: 'status',
      text: 'Состояние',
      formatter: (_, item) => <StatusFormatterWithProblem item={item} />,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'status',
      text: 'Работа устройства',
      formatter: (_, a) => (<CamerasWorkingStateFormatter item={a} isPopup={false} />),
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'metrics',
      text: 'Процессинг',
      formatter: processingFormatter,
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: '',
      text: 'Действие',
      formatter: (_, a) => (<CamerasActionsFormatter item={a} />),
      disableSort: true,
      dataClassName: 'align-middle',
    },
  ];

  const cameraRf = useRef(null);

  useEffect(() => {
    if (cameraRf && cameraRf.current) {
      cameraRf.current.scrollTo(0, 0);
    }
  }, [camerasListMeta.page]);

  return (
    <div className="parking-meter-table g-0">
      <div className="frame">
        <div className="sticky-table-wrapper custom-scroll-theme" ref={cameraRf}>
          <Grid
            sort={sort}
            changeSort={changeSort}
            loading={loading}
            className="parking-meter-grid cameras-grid"
            columns={columns}
            data={camerasList}
            rowClassFormatter={item => optionClassFormatter(item.available_status)}
          />
        </div>
      </div>
      <Pagination meta={camerasListMeta} list={camerasList} handleChangeMeta={handleLoadingCamerasList} />
    </div>
  );
}
